// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    apiTrafico: "https://api.softoursistemas.com/v2trafico/api/",
    apiVTC: "https://api.softoursistemas.com/vtc/api/",
    apiTaller: "https://api.softoursistemas.com/taller/api/",
    apiMatrix: "https://api.softoursistemas.com/plannermatrix/api/",
    apiTAD: "-apitad.softoursistemas.com/api/",
    apiMensajeria: "https://api.softoursistemas.com/mensajeria/",

    lat: 39.478645,
    lng: -0.45223,
    userPusers: "PlannerBusApps",
    pswPusers: "20Planner13",
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
